import React from 'react';
import Selectors from '../hooks/selectors';
import WorkspaceRequestDialog from './WorkspaceRequestDialog';

const WorkspaceDialogs = ({ theme }) => {
  const { allowReceipt } = Selectors.useWorkspaceDialogs();
  return (
    <>
      {allowReceipt && (<WorkspaceRequestDialog theme={theme} />)}
    </>
  );
};

export default WorkspaceDialogs;
